import {Box} from '../types/box'

export const resolveBoxDisplayName = (box: Pick<Box, 'name' | 'location'>) => {
  const locationName = box.location?.name

  if (locationName) {
    return `${box.name} (${locationName})`
  }
  return box.name
}
